<template>
  <div class="footer">
    <div class="l">
      <div class="l_tent">
        <img
            style="width: 80%"
            src="../../../assets/images/official-logo.png"
            alt=""
        />
        <div style="color: #ccc">
          公司地址：江苏省南京市太平南路166号
        </div>
        <!--        <div class="beian" style="color: #ccc;padding: 5px 0;" >-->
        <!--          <img style="width: 20px;height: 22px;margin-right: 8px;" src="../../../assets/images/beianhao.png" alt="">-->
        <!--          <el-link target="_blank" type="info" style="font-size: 16px;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102007288">京公网安备11010102007288号</el-link>-->
        <!--        </div>-->
        <div class="beian" style="color: #ccc">
          备案号：
          <el-link target="_blank" type="info" style="font-size: 16px;" href="https://beian.miit.gov.cn">
            苏ICP备2024108457号
          </el-link>
        </div>
      </div>
      <div class="l_tent1">
        <img
            style="width: 60px; padding-right: 5px;"
            src="../../../assets/images/download.png"
            alt=""
        />
        <div>
          <div style="color: #ccc;">联系电话：</div>
          <div style="color: #fff; font-weight: 700; font-size: 46px;">15905175428</div>
        </div>
      </div>
    </div>
    <div class="r"></div>
  </div>
</template>

<script>

export default {
  name: "Footer",

  data() {
    return {}
  },

  mounted() {
    // 获取缓存的数据
    // const cachedFooterData = localStorage.getItem("footerData");
    // 如果有缓存的数据，则使用缓存的数据
    // if (cachedFooterData) {
    //   this.footerData = JSON.parse(cachedFooterData);
    // } else {
    //   this.fetchFooterData();
    // }
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.footer {
  background: #242f41 bottom;
  padding: 80px;

  .l {
    display: flex;
    justify-content: center;

    .l_tent {
      width: 500px;
      padding-right: 70px;
      border-right: 1px solid hsla(0, 0%, 100%, 0.1);
    }

    .l_tent1 {
      padding: 30px;
      width: 500px;
      display: flex;
      align-items: center;
    }
  }
}

.beian {
  display: flex;
}
</style>